<script setup="setup" lang="ts">
import type { ModelRef } from "vue";

const { t, availableLocales } = useI18n();

const language: ModelRef<string | undefined> = defineModel<string>();

const props = defineProps<{
  disabled?: boolean | null;
}>();
</script>
<template>
  <lxc-select
    v-model="language"
    :disabled="props.disabled"
    select-filter
    :select-search-placeholder="t('input.select.search.placeholder')"
    :select-no-result-text="t('input.select.search.noResults')"
  >
    <lxc-option
      v-for="item in availableLocales"
      :key="item"
      :label="t('input.languages.' + item)"
      :value="item"
    />
  </lxc-select>
</template>
